import { render, staticRenderFns } from "./LotteryReservationPopup.vue?vue&type=template&id=4dbb9b1f&scoped=true&"
import script from "./LotteryReservationPopup.vue?vue&type=script&lang=js&"
export * from "./LotteryReservationPopup.vue?vue&type=script&lang=js&"
import style0 from "./LotteryReservationPopup.vue?vue&type=style&index=0&id=4dbb9b1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbb9b1f",
  null
  
)

export default component.exports